/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { Button, InputAdornment, TextField } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import { activateAccount as activateUser, getUserDetails } from '../utils/AuthUtil'
import LoadingButton from '@mui/lab/LoadingButton'
import ReactGA4 from 'react-ga4'
import PostHogTracker from '../utils/PostHogTracker'
import { InputOTP, InputOTPGroup, InputOTPSlot } from '../Components/ui/input-otp'
import { REGEXP_ONLY_DIGITS } from 'input-otp'
import CreateSharpIcon from '@mui/icons-material/CreateSharp'

const ActivateAccountOTP = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const [errorMessage, setErrorMessage] = useState(null)
  const [otp, setOtp] = useState(null)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (location) {
      setPhoneNumber(
        typeof location.state?.phoneNumber === 'number'
          ? location.state?.phoneNumber.toString()
          : location.state?.phoneNumber,
      )
      setMessage(location.state?.message)
    }
  }, [])

  const handleChange = (value) => {
    setOtp(value)
  }

  const activateAccount = async (event) => {
    event.preventDefault()
    setErrorMessage(null)
    const payload = {
      phoneNumber,
      otp,
    }
    try {
      const response = await activateUser(payload)
      ReactGA4.event({
        category: 'Login',
        action: 'Login OTP Entered',
      })
      PostHogTracker.otpEntered('signup')
      setLoading(false)

      // console.log(response)
      if (response.isError) {
        if (response.code === 'Unauthorized') {
          setErrorMessage('Enter Valid OTP.')
        } else {
          setErrorMessage('You entered an incorrect OTP!')
        }
        ReactGA4.event({
          category: 'Login',
          action: 'Login OTP Failure',
        })
        PostHogTracker.otpFailure('signup', 'invalid_otp')
        PostHogTracker.signupOtpFailed('invalid_otp')
        // console.log(fbq, 'is fbq')
        fbq('track', 'Sign Up OTP - Invalid OTP')
        ReactGA4.event({
          category: 'View',
          action: 'Sign Up OTP - Invalid OTP',
          value: 'Sign Up OTP - Invalid OTP',
        })
        var custom_data = {
          Custom_Event_Property_Key1: 'Sign Up OTP - Invalid OTP',
        }

        branch.logEvent('Sign Up OTP - Invalid OTP', custom_data, function (err) {
          console.log(err)
        })
      }

      const userDetails = getUserDetails()
      // console.log('GA event', userDetails.email)
      ReactGA4.event({
        category: 'Login',
        action: 'Login Complete',
        value: userDetails.email,
      })

      // Use enhanced PostHog identification with super properties
      // Using phone number as distinct ID (works for both KYC and non-KYC users)
      PostHogTracker.signupCompleted(phoneNumber, userDetails, 'otp')
      PostHogTracker.firstLoginAfterSignup(phoneNumber)
      fbq('track', 'Sign Up OTP - First Login')
      ReactGA4.event({
        category: 'View',
        action: 'Sign Up OTP - First Login',
        value: 'Sign Up OTP - First Login',
      })

      // eslint-disable-next-line no-redeclare
      var custom_data = {
        Custom_Event_Property_Key1: 'Sign Up OTP - First Login',
      }

      branch.logEvent('Sign Up OTP - First Login', custom_data, function (err) {
        console.log(err)
      })

      if (window.utmData && window.utmData['$marketing_title']) {
        if (window.utmData['$marketing_title'] === 'Insurance') {
          navigate('/dashboard/insurance')
        } else {
          let navState = null
          if (window.utmData.navigation_state) {
            navState = JSON.parse(window.utmData.navigation_state)
            // console.log(navState)
          }
          if (window.utmData.site_url) {
            navigate(window.utmData.site_url, { state: navState })
          } else {
            navigate('/user-source', { state: { phoneNumber } })
            // navigate('/dashboard', { state: { login: true } })
          }
        }
      } else {
        navigate('/user-source', { state: { phoneNumber } })
        // navigate('/dashboard', { state: { login: true } })
      }
    } catch (e) {
      setLoading(false)
      return
    }
  }

  return (
    <div className='mx-auto flex w-full max-w-[360px] min-w-0 flex-col items-center justify-center lg:max-w-[432px]'>
      <div className='mb-6 flex w-full flex-col gap-y-1'>
        <h1 className='text-center font-IBM text-[28px] font-bold leading-9 text-black-950 lg:text-[36px] lg:leading-10 dark:text-[var(--fb-text)]'>
          Enter OTP
        </h1>
        <p className='text-center font-IBM text-sm font-medium leading-5 text-black-400 dark:text-black-300'>
          Get started in a few easy steps
        </p>
      </div>

      <div className='mb-6 flex w-full flex-col items-center justify-center'>
        <p className='text-center font-IBM text-sm font-medium leading-5 text-black-400 dark:text-black-300'>
          Enter the OTP sent to
        </p>
        <span
          className='flex cursor-pointer items-center justify-center gap-x-1 border-b-2 border-dashed border-primary-500 font-IBM text-sm font-semibold leading-5 text-primary-500'
          onClick={() => navigate('/login')}
        >
          {phoneNumber}
          <CreateSharpIcon sx={{ fontSize: '16px' }} />
        </span>
      </div>

      <Grid item xs={12} sx={{ mb: 2 }}>
        <form onSubmit={activateAccount}>
          <InputOTP
            maxLength={6}
            pattern={REGEXP_ONLY_DIGITS}
            value={otp}
            onChange={(value) => handleChange(value)}
            containerClassName='w-full'
          >
            <InputOTPGroup className='w-full justify-between'>
              {[0, 1, 2, 3, 4, 5].map((index) => (
                <InputOTPSlot
                  key={index}
                  index={index}
                  className={`${
                    errorMessage && 'border-red-500'
                  } h-11 w-9 rounded-xl border-[#D3DBEC] bg-transparent px-0 text-black-950 min-[360px]:h-12 min-[360px]:w-11 dark:border-[#3a3d56] dark:text-[var(--fb-text)]`}
                />
              ))}
            </InputOTPGroup>
          </InputOTP>

          <div className='text-center text-xs text-red-600 font-medium mt-2'>
            {errorMessage && <>{errorMessage}</>}
          </div>
          {/* <div>
            <TextField
              required
              id='component-outlined'
              type='text'
              onChange={(e) => setOtp(e.target.value)}
              fullWidth
              value={otp}
              inputProps={{
                maxLength: 6,
                inputMode: 'numeric',
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <div
                      aria-label='toggle password visibility'
                      onClick={() => {
                        PostHogTracker.buttonClicked('Resend OTP', {
                          page_name: 'Signup OTP',
                          context: 'resend'
                        })
                        fbq('track', 'Sign Up OTP - Resend OTP Clicked')  
                        ReactGA4.event({
                          category: 'View',
                          action: 'Sign Up OTP - Resend OTP Clicked',
                          value: 'Sign Up OTP - Resend OTP Clicked',
                        })
                        var custom_data = {
                          Custom_Event_Property_Key1: 'Sign Up OTP - Resend OTP Clicked',
                        }

                        branch.logEvent(
                          'Sign Up OTP - Resend OTP Clicked',
                          custom_data,
                          function (err) {
                            console.log(err)
                          },
                        )
                      }}
                      onMouseDown={() => {}}
                      className='resend-otp cursor-pointer'
                    >
                      Resend OTP
                    </div>
                  </InputAdornment>
                ),
              }}
              variant='standard'
              onBlur={() => {
                PostHogTracker.signupOtpEntered()
                fbq('track', 'Sign Up OTP - OTP Entered')
                ReactGA4.event({
                  category: 'View',
                  action: 'Sign Up OTP - OTP Entered',
                  value: 'Sign Up OTP - OTP Entered',
                })
                var custom_data = {
                  Custom_Event_Property_Key1: 'Sign Up OTP - OTP Entered',
                }

                branch.logEvent('Sign Up OTP - OTP Entered', custom_data, function (err) {
                  console.log(err)
                })
              }}
            />
          </div> */}
          <LoadingButton
            variant='contained'
            loading={loading}
            sx={{
              mt: '24px',
              height: '40px',
              px: '12px',
              fontSize: '14px',
              lineHeight: '20px',
              fontWeight: '600',
              fontFamily: 'IBM Plex Sans',
              textTransform: 'none',
              borderRadius: '12px',
              boxShadow: '0 10px 24px rgba(40, 24, 255, 0.18)',
              '&:hover': {
                backgroundColor: '#2818ff',
                boxShadow: '0 10px 24px rgba(40, 24, 255, 0.18)',
              },
              '&:active': { backgroundColor: '#2818ff', boxShadow: 'none' },
              '&.Mui-disabled': {
                backgroundColor: '#97aaff',
                color: '#fff',
                opacity: 1,
              },
            }}
            disabled={!(otp?.length === 6)}
            fullWidth
            onClick={(event) => {
              setLoading(true)
              activateAccount(event)
            }}
          >
            Verify OTP
          </LoadingButton>
        </form>
      </Grid>
    </div>
  )
}

export default ActivateAccountOTP
